// This file was automatically generated from appanalytics.reports.navPanel.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appanalytics.reports.navPanel');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appanalytics.reports.navPanel.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.total_records) ? '<div class="el8ReportNavigationLeftSection"><button class="patients-select-all el8SmallButton">Select All</button><span id="patientsSelectedInfo" class="ml10" style="font-size: 12px;"></span></div><ul class="el8NavWrap el8AlignRight el8Spacer5 el8ReportNavigationRightSection"><li class="el8NavItem"><a class="goto-page-trigger el8StandardLink" _page="0">First</a></li><li class="el8NavItem">' + ((opt_data.page > 0) ? '<a class="prev-page-trigger el8StandardLink">Prev</a>' : '') + '</li><li class="el8NavItem"><span class="el8AppText">Showing ' + soy.$$escapeHtml(opt_data.first_record) + ' - ' + soy.$$escapeHtml(opt_data.last_record) + '  of ' + soy.$$escapeHtml(opt_data.total_records) + '</span></li><li class="el8NavItem">' + ((opt_data.more_results_exist) ? '<a class="next-page-trigger el8StandardLink">Next</a>' : '') + '</li><li class="el8NavItem"><a class="goto-page-trigger el8StandardLink" _page="' + soy.$$escapeHtml(opt_data.last_page) + '">Last</a></li></ul>' : '');
  if (!opt_sb) return output.toString();
};
